import React from "react";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import "./backbutton.css";
import { RoleToLinkMapper } from "../../../utils/UrlUtils";
import { useGetRole } from "../../hooks/useGetRole";
const BackButton = () => {
  const navigate = useNavigate();
  const role = useGetRole()

  const goBack = () => {
    if (window.history.length > 1) {
      navigate(-1); // Go back if there's history
    } else {
      navigate(`${RoleToLinkMapper(role)}homepage`)
    }
  };

  return (
    <>
      <ArrowBackIcon fontSize="large" onClick={goBack} className="back-button-style" />
    </>
  );
};

export default BackButton;
